// ==== Pricing / state / share-link / cart wiring ====
(function () {
  'use strict';
  // ---------------------------------------------------------------
  // v2 addition: chain / itemized pricing / share link
  // Deliberately kept separate from the original customizer script above —
  // reads its output (#nm-price) via MutationObserver rather than touching
  // its internals, so the locked customizer logic stays untouched.
  // (Back engraving was removed 2026-09-14 — "keeping it simple".)
  // ---------------------------------------------------------------
  var CHAIN_BASE = { cuban: 18, curb: 15, box: 16, rope: 14, none: 0 };   // placeholder £
  var LENGTH_SURCHARGE = { '16': 0, '18': 2, '20': 4 };                   // placeholder £
  // Silver purity and metal thickness were both removed as customer choices
  // on 2026-09-21 ("we sticking to 925 only" / "let's remove metal thickness
  // option, as it will help us removing variants") — every plate is now a
  // fixed 925 sterling, 0.70mm spec, so there's no surcharge or label table
  // to look up any more.

  var CONSTRUCTION_NOTES = {
    rail: 'Floating Letters + Rail — each letter is its own solid cut piece, joined along the bottom by a connecting bar so the whole name laser-cuts and survives as one piece. This is the current 3D preview’s actual build. Letters and numbers (A–Z, 0–9) — symbols can’t be cut as floating pieces on this build.',
    engraved: 'Engraved Plate — the name is engraved into the face of a solid silver plate rather than cut through it. No floating letters, no connecting rail.',
    connected: 'Connected Letters — the same solid, beveled cut letters as Floating + Rail, but with no connecting bar underneath. The letters sit close enough to physically touch their neighbours instead, so the whole name survives the cut as one piece on spacing alone. Letters and numbers only (A–Z, 0–9), no spaces — every character has to touch the next.'
  };

  var chainTypeRow = document.getElementById('nm-chain-type-row');
  var chainLengthRow = document.getElementById('nm-chain-length-row');
  var chainPriceEl = document.getElementById('nm-chain-price');
  var plateAmtEl = document.getElementById('nm-price');
  var grandTotalEl = document.getElementById('nm-grand-total');
  var shareBtn = document.getElementById('nm-share');
  var nameInput = document.getElementById('nm-name');
  var constructionRow = document.getElementById('nm-construction-row');
  var constructionNote = document.getElementById('nm-construction-note');
  var specRailNote = document.getElementById('nm-spec-rail-note');

  var state = { chain: 'cuban', length: '16', construction: 'rail' };

  // All three constructions now have real 3D geometry in the preview —
  // Engraved Plate (2026-09-15) and Connected Letters (2026-09-16) were
  // both ported in from their standalone R&D artifacts. Cut-Out Plate was
  // dropped from scope entirely (2026-09-15) and no longer appears as an
  // option at all.

  function applyConstruction() {
    if (constructionNote && CONSTRUCTION_NOTES[state.construction]) {
      constructionNote.textContent = CONSTRUCTION_NOTES[state.construction];
    }
    // The "CONNECTING RAIL required" spec label is specific to the
    // Floating + Rail build — Engraved Plate and Connected Letters have
    // no rail, so it's misleading on either of those.
    if (specRailNote) {
      specRailNote.style.display = (state.construction === 'rail') ? '' : 'none';
    }
  }

  function setActive(row, attr, value) {
    if (!row) return;
    var btns = row.querySelectorAll('.opt');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('active', btns[i].getAttribute(attr) === value);
    }
  }

  function recalc() {
    var chainOn = state.chain !== 'none';
    chainLengthRow.style.opacity = chainOn ? '1' : '.35';
    chainLengthRow.style.pointerEvents = chainOn ? 'auto' : 'none';

    var chainPrice = chainOn ? (CHAIN_BASE[state.chain] + (LENGTH_SURCHARGE[state.length] || 0)) : 0;
    chainPriceEl.textContent = chainPrice.toFixed(2);

    // No thickness/purity surcharge lines any more — both are fixed, so
    // the grand total is just the lettered plate plus the chain.
    var plate = parseFloat(plateAmtEl.textContent) || 0;
    var grand = plate + chainPrice;
    grandTotalEl.textContent = grand.toFixed(2);
  }

  if (constructionRow) {
    constructionRow.addEventListener('click', function (e) {
      var btn = e.target.closest('.opt');
      if (!btn) return;
      state.construction = btn.getAttribute('data-construction');
      setActive(constructionRow, 'data-construction', state.construction);
      applyConstruction();
    });
  }

  if (chainTypeRow) {
    chainTypeRow.addEventListener('click', function (e) {
      var btn = e.target.closest('.opt');
      if (!btn) return;
      state.chain = btn.getAttribute('data-chain');
      setActive(chainTypeRow, 'data-chain', state.chain);
      recalc();
    });
  }
  if (chainLengthRow) {
    chainLengthRow.addEventListener('click', function (e) {
      var btn = e.target.closest('.opt');
      if (!btn) return;
      state.length = btn.getAttribute('data-length');
      setActive(chainLengthRow, 'data-length', state.length);
      recalc();
    });
  }
  // Recompute whenever the locked customizer updates the plate price —
  // observed, not hooked, so the original script needs no changes.
  if (plateAmtEl && window.MutationObserver) {
    new MutationObserver(recalc).observe(plateAmtEl, { characterData: true, childList: true, subtree: true });
  }

  // ---------------- Shareable design link ----------------
  function currentFont() {
    var b = document.querySelector('#nm-font-row .opt.active');
    return b ? b.getAttribute('data-font') : 'plex';
  }
  function currentFinish() {
    var b = document.querySelector('#nm-finish-row .opt.active');
    return b ? b.getAttribute('data-finish') : 'polished';
  }
  function buildShareUrl() {
    var params = new URLSearchParams();
    params.set('name', nameInput ? nameInput.value : '');
    params.set('font', currentFont());
    params.set('finish', currentFinish());
    params.set('chain', state.chain);
    params.set('length', state.length);
    params.set('construction', state.construction);
    var url = window.location.origin + window.location.pathname + '?' + params.toString();
    return url;
  }

  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var url = buildShareUrl();
      var done = function () {
        var original = shareBtn.textContent;
        shareBtn.textContent = 'Link copied!';
        setTimeout(function () { shareBtn.textContent = original; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link:', url); });
      } else {
        window.prompt('Copy this link:', url);
      }
    });
  }

  // ---------------- Restore state from a shared link ----------------
  function restoreFromQuery() {
    var q = new URLSearchParams(window.location.search);
    if (!q.has('name') && !q.has('font') && !q.has('finish') && !q.has('construction')) return;

    // Construction is restored before name: the locked customizer script
    // sanitizes typed/pasted text against whichever construction is
    // currently active (Floating + Rail allows letters only), so setting
    // construction first means a shared link's name isn't stripped against
    // the wrong (default) construction before its own choice applies.
    if (q.has('construction')) {
      var kb = document.querySelector('#nm-construction-row .opt[data-construction="' + q.get('construction') + '"]');
      if (kb) kb.click();
    }
    if (q.has('name') && nameInput) {
      nameInput.value = q.get('name');
      nameInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
    if (q.has('font')) {
      var fb = document.querySelector('#nm-font-row .opt[data-font="' + q.get('font') + '"]');
      if (fb) fb.click();
    }
    if (q.has('finish')) {
      var xb = document.querySelector('#nm-finish-row .opt[data-finish="' + q.get('finish') + '"]');
      if (xb) xb.click();
    }
    if (q.has('chain')) {
      state.chain = q.get('chain');
      setActive(chainTypeRow, 'data-chain', state.chain);
    }
    if (q.has('length')) {
      state.length = q.get('length');
      setActive(chainLengthRow, 'data-length', state.length);
    }
  }

  // ---------------- Add to cart (real Shopify wiring) ----------------
  // NEW for the Shopify push — the design-prototype version of this file
  // had no real add-to-cart at all (see the section's own disclaimer
  // copy, since replaced). window.__C0DE93_VARIANT_ID is printed by the
  // Liquid section itself from the merchant's "Product to add to cart"
  // setting (see sections/c0de93-nameplate-customizer.liquid) — falsy
  // until that setting is configured in the theme editor. It now only
  // serves as a last-resort fallback (see resolveVariantId below) — the
  // real variant used is looked up per-configuration against the
  // 130-variant pricing matrix (Letters × Chain — the Metal dimension was
  // removed 2026-09-21 along with the purity/thickness choices themselves,
  // since every plate is now a single fixed 925/0.70mm spec) so checkout
  // always charges the correct automatic price for what was actually built.
  var ctaBtn = document.getElementById('nm-cta');
  var cartStatusEl = document.getElementById('nm-cart-status');

  function activeOptText(rowId) {
    var b = document.querySelector('#' + rowId + ' .opt.active');
    return b ? b.textContent.trim() : '';
  }

  function activeOptAttr(rowId, attr) {
    var b = document.querySelector('#' + rowId + ' .opt.active');
    return b ? b.getAttribute(attr) : null;
  }

  // ---------------- Variant matrix lookup (true automatic pricing) ----------------
  // Every valid combination of Letters (1-10) × Chain (type+length, 13
  // values) exists as a real priced Shopify variant on the connected
  // product — see productOptionsCreate/productVariantsBulkUpdate setup
  // notes in README-setup.md. This fetches that product's public variant
  // list once and builds an in-memory "Letters|Chain" -> variant id map, so
  // Add to Bag always sends the one variant whose fixed Shopify price
  // matches the design on screen — checkout then charges exactly that,
  // automatically, with no manual review and no custom backend. (There's
  // no Metal dimension any more — every plate is the same fixed 925
  // sterling, 0.70mm spec, so it's not a choice that needs its own priced
  // variant axis.)
  var variantLookupPromise = null;

  function loadVariantLookup() {
    if (variantLookupPromise) return variantLookupPromise;
    var handle = (window.__C0DE93_PRODUCT_HANDLE || '');
    if (!handle) {
      variantLookupPromise = Promise.reject(new Error('No product connected.'));
      return variantLookupPromise;
    }
    variantLookupPromise = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not load pricing data.');
        return res.json();
      })
      .then(function (product) {
        var map = {};
        (product.variants || []).forEach(function (v) {
          map[v.option1 + '|' + v.option2] = v.id;
        });
        return map;
      });
    return variantLookupPromise;
  }

  function currentChainOption() {
    if (state.chain === 'none') return 'None';
    var cap = state.chain.charAt(0).toUpperCase() + state.chain.slice(1);
    return cap + '-' + state.length;
  }

  function currentLettersOption() {
    var el = document.getElementById('nm-letter-count');
    var n = el ? parseInt(el.textContent, 10) : NaN;
    if (!n || n < 1) return null;
    if (n > 10) n = 10; // matches the Letters option's max priced value
    return String(n);
  }

  function resolveVariantId(lookup) {
    var letters = currentLettersOption();
    if (!letters || !lookup) return null;
    var key = letters + '|' + currentChainOption();
    return lookup[key] || null;
  }

  // ---------------- 3D preview snapshot (for cart / checkout) ----------------
  // The <canvas id="gl"> is created with preserveDrawingBuffer: true in
  // c0de93-nameplate-customizer-core.js specifically so toDataURL() works
  // here. Downscaled + JPEG-compressed to keep the resulting line item
  // property small — Shopify carts aren't built for multi-hundred-KB
  // property values, so this fails quietly (no image, everything else in
  // the order still works) rather than risking a broken add-to-cart.
  var SNAPSHOT_MAX_DIMENSION = 320; // px, longest side of the thumbnail
  var SNAPSHOT_MAX_CHARS = 250000;  // ~185KB of actual image data — safety ceiling

  function captureSnapshot() {
    try {
      var glCanvas = document.getElementById('gl');
      if (!glCanvas || !glCanvas.width || !glCanvas.height) return '';
      var scale = Math.min(1, SNAPSHOT_MAX_DIMENSION / Math.max(glCanvas.width, glCanvas.height));
      var tw = Math.max(1, Math.round(glCanvas.width * scale));
      var th = Math.max(1, Math.round(glCanvas.height * scale));
      var thumb = document.createElement('canvas');
      thumb.width = tw;
      thumb.height = th;
      var ctx = thumb.getContext('2d');
      // JPEG has no alpha channel — flatten onto white first so the plate
      // doesn't get a black background.
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, tw, th);
      ctx.drawImage(glCanvas, 0, 0, tw, th);
      var dataUrl = thumb.toDataURL('image/jpeg', 0.72);
      if (!dataUrl || dataUrl.length > SNAPSHOT_MAX_CHARS) return '';
      return dataUrl;
    } catch (e) {
      // Canvas can throw (e.g. tainted by a cross-origin texture) — never
      // let a snapshot failure block adding the item to the cart.
      return '';
    }
  }

  function buildLineItemProperties() {
    var props = {
      'Text': nameInput ? nameInput.value : '',
      'Construction': activeOptText('nm-construction-row') || state.construction,
      'Font': activeOptText('nm-font-row') || currentFont(),
      'Finish': activeOptText('nm-finish-row') || currentFinish(),
      // Silver purity and metal thickness are no longer customer choices
      // (2026-09-21) — every plate is the same fixed 925 sterling, 0.70mm
      // spec, so these are printed as plain info on the order rather than
      // read back from a UI row that no longer exists.
      'Silver purity': '925 Sterling',
      'Metal thickness': '0.70mm',
      'Chain': activeOptText('nm-chain-type-row') || state.chain,
      'Chain length': state.chain === 'none' ? 'n/a' : (state.length + '″')
    };
    // Leading underscore = a Shopify "hidden" property: it rides along on
    // the line item and is readable in Liquid (item.properties['_Preview
    // Image']) and via /cart.js, but Shopify's default cart/checkout property
    // list won't print the raw data URL as text next to the other options.
    var snapshot = captureSnapshot();
    if (snapshot) props['_Preview Image'] = snapshot;
    // Raw internal keys (not display labels) for the cart's live rotating
    // 3D preview — see assets/c0de93-cart-preview-3d.js, which rebuilds
    // this exact plate shape from these keys rather than the display text
    // above, so it doesn't depend on button labels never changing. Metal
    // thickness is fixed now, but the key stays (hardcoded to 'standard')
    // since c0de93-cart-preview-3d.js's own THICKNESS_MM map still reads it.
    props['_Design Keys'] = JSON.stringify({
      text: nameInput ? nameInput.value : '',
      construction: activeOptAttr('nm-construction-row', 'data-construction') || state.construction,
      font: activeOptAttr('nm-font-row', 'data-font') || 'plex',
      finish: activeOptAttr('nm-finish-row', 'data-finish') || 'polished',
      thickness: 'standard'
    });
    return props;
  }

  function setCartStatus(msg, isError) {
    if (!cartStatusEl) return;
    cartStatusEl.textContent = msg;
    cartStatusEl.style.color = isError ? 'var(--red, #c0392b)' : 'var(--red-dim, #8A000A)';
  }

  if (ctaBtn) {
    if (!window.__C0DE93_VARIANT_ID) {
      // Not wired to a real product yet — fail loudly here, during setup,
      // rather than silently in front of a customer.
      ctaBtn.disabled = true;
      setCartStatus('Not connected to a product yet — set one in this section’s settings in the theme editor.', true);
    } else {
      // Kick the variant matrix off early so it's usually already cached
      // by the time someone clicks Add to Bag — click handler below still
      // awaits it, so a slow/late load never breaks the add.
      loadVariantLookup().catch(function () { /* retried on click */ });

      ctaBtn.addEventListener('click', function () {
        if (ctaBtn.disabled) return;
        var raw = nameInput ? nameInput.value : '';
        if (!raw.replace(/\s/g, '').length) {
          setCartStatus('Type a name or word first.', true);
          return;
        }
        var original = ctaBtn.textContent;
        ctaBtn.disabled = true;
        ctaBtn.textContent = 'Adding…';
        setCartStatus('');

        loadVariantLookup()
          .catch(function () { return null; }) // fall through to the fallback variant below
          .then(function (lookup) {
            // Prefer the exact priced variant for this configuration; if
            // the matrix hasn't loaded or somehow has no matching
            // combination, fall back to the section's connected variant
            // rather than blocking the add entirely.
            var variantId = resolveVariantId(lookup) || window.__C0DE93_VARIANT_ID;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items: [{
                  id: variantId,
                  quantity: 1,
                  properties: buildLineItemProperties()
                }]
              })
            });
          })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                throw new Error((err && err.description) || 'Could not add to bag.');
              });
            }
            return res.json();
          })
          .then(function () {
            ctaBtn.textContent = 'Added!';
            setCartStatus('Added to your bag.');
            // Many themes listen for this to refresh a cart drawer/count —
            // harmless no-op if nothing's listening.
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            setTimeout(function () {
              ctaBtn.textContent = original;
              ctaBtn.disabled = false;
            }, 1800);
          })
          .catch(function (err) {
            ctaBtn.textContent = original;
            ctaBtn.disabled = false;
            setCartStatus((err && err.message) || 'Could not add to bag — try again.', true);
          });
      });
    }
  }

  applyConstruction();
  restoreFromQuery();
  recalc();
})();
